import { ReactComponent as SaveAsTemplateIcon } from "assets/images/iconsV2/save-as-template.svg";
import testIds from "constants/testIds";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import ActionButton from "../../common/TopNavV2/TopNavActions/ShipperProviderActions/ActionButton";

function TemplatesMenuItem({ openTemplateDialog }) {
  return (
    <ActionButton
      onClick={() => {
        openTemplateDialog();
      }}
      icon={<SaveAsTemplateIcon width={16} height={16} />}
      title={<FormattedMessage id="components.molecules.navigation.saveTemplate" defaultMessage="Save as template" />}
      testId={testIds.SHIPMENT_DASHBOARD_SAVE_TEMPLATE_BUTTON}
    />
  );
}

TemplatesMenuItem.propTypes = {
  openTemplateDialog: PropTypes.func.isRequired,
};

export default TemplatesMenuItem;
